export class UserPreferencesModel implements IUserPreferencesModel {
  companyOpportunityViewDefault?: string | undefined;
  userId?: string | undefined;
  dateCreated?: Date | undefined;
  dateUpdated?: Date | undefined;

  constructor(data?: IUserPreferencesModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.companyOpportunityViewDefault = Data["companyOpportunityViewDefault"];
      this.userId = Data["userId"];
      this.dateCreated = Data["dateCreated"] ? new Date(Data["dateCreated"].toString()) : <any>undefined;
      this.dateUpdated = Data["dateUpdated"] ? new Date(Data["dateUpdated"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): UserPreferencesModel {
    data = typeof data === 'object' ? data : {};
    let result = new UserPreferencesModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["companyOpportunityViewDefault"] = this.companyOpportunityViewDefault;
    data["userId"] = this.userId;
    data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
    data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
    return data;
  }
}

export interface IUserPreferencesModel {
  companyOpportunityViewDefault?: string | undefined;
  userId?: string | undefined;
  dateCreated?: Date | undefined;
  dateUpdated?: Date | undefined;
}